export const declaredProducts = {
  title: 'Sản phẩm khai báo',
  resourceName: 'Sản phẩm khai báo',
  titles: {
    list: 'Danh sách sản phẩm khai báo',
    detail: 'Chi tiết sản phẩm khai báo',
    create: 'Thêm sản phẩm khai báo',
    edit: 'Sửa sản phẩm khai báo',
    addQuick: 'Thêm nhanh',
  },
  sections: {
    basic: 'Thông tin cơ bản',
    audit: 'Hệ thống',
    linkedInternalProducts: 'Sản phẩm nội bộ liên kết',
  },
  hints: {
    codeStaff: 'Mã SPKB do nhân viên nhập',
  },
  fields: {
    code: 'Mã SPKB',
    name: 'Tên sản phẩm khai báo',
    description: 'Mô tả',
    note: 'Ghi chú',
    status: 'Trạng thái',
    onOffAction: 'Bật / Tắt',
    createdAt: 'Ngày tạo',
    updatedAt: 'Ngày cập nhật',
    actions: 'Thao tác',
    internalCode: 'Mã SP nội bộ',
    internalName: 'Tên SP nội bộ',
    internalProduct: 'Sản phẩm nội bộ',
  },
  status: {
    active: 'Hoạt động',
    inactive: 'Ngưng',
  },
  actions: {
    addInternalProduct: 'Thêm SP nội bộ',
  },
  messages: {
    noData: 'Chưa có sản phẩm khai báo',
    noLinkedProducts: 'Chưa liên kết sản phẩm nội bộ',
    exportSuccess: 'Xuất Excel thành công',
    exportFailed: 'Xuất Excel thất bại',
    importSuccess: 'Nhập Excel thành công',
    importFailed: 'Nhập Excel thất bại',
    importDescription: 'Chọn đúng file theo mẫu Excel để nhập sản phẩm khai báo (hỗ trợ liên kết N-N với SP nội bộ).',
  },
}
